<template>
  <div>
    <div :class="[$style.title, 'login-heading']">
      <h1>
        <strong>WELCOME TO PAY2ALL</strong>
      </h1>
    </div>
    <div :class="$style.block">
      <div class="row">
        <div class="col-xl-12">
          <div :class="$style.inner">
            <div :class="$style.form">
              <h4 class="text-uppercase">
                <strong>Please log in</strong>
              </h4>
              <a-form class="login-form" @submit.prevent="onSubmit">
                <a-form-item label="Email">
                  <a-input
                    placeholder="Email"
                    v-model="form.email"
                    v-decorator="['email']"
                  >
                    <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25);"/>
                  </a-input>
                </a-form-item>
                <a-form-item label="Password">
                  <a-input
                    v-model="form.password"
                    placeholder="Password"
                    type="password"
                    v-decorator="['password']"
                  >
                    <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25);"/>
                  </a-input>
                </a-form-item>
                <div>
                  <a-checkbox>Remember me</a-checkbox>
                  <router-link
                    class="pull-right text-primary utils__link--blue utils__link--underlined"
                    to="/user/forgot"
                  >Forgot password?</router-link>
                </div>
                <div class="form-actions">
                  <a-button
                    type="primary"
                    htmlType="submit"
                    class="login-form-button width-150"
                  >Sign in</a-button>
                  <span class="ml-3 register-link">
                    <a
                      href="javascript: void(0);"
                      class="text-primary utils__link--underlined mr-1"
                    >Register</a> if you don&#39;t have account
                  </span>
                </div>
                <div class="form-group">
                  <p>Use another service to Log In</p>
                  <div class="mt-2">
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-facebook"/>
                    </a>
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-google"/>
                    </a>
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-windows"/>
                    </a>
                    <a href="javascript: void(0);" class="btn btn-icon mr-2">
                      <i class="icmn-twitter"/>
                    </a>
                  </div>
                </div>
              </a-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  data: function () {
    return {
      form: {
        email: '',
        password: '',
      },
      error: '',
      errors: {},
    }
  },
  computed: {
    ...mapState({
      me: state => state.auth.me,
    }),
  },

  methods: {
    ...mapActions([
      'login',
    ]),

    onSubmit () {
      this.errors = {}
      this.login(this.form)
        .then(() => {
          this.$nprogress.done()
          this.$notification['success']({
            message: 'Logged In',
            description: 'You have successfully logged in!',
          })
          this.$router.push('/dashboard')
        })
        .catch((error) => {
          this.$nprogress.done()
          this.$notification['warning']({
            message: error.message,
            description: error.message,
          })
        })
    },
  },
}
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
